var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 168,
    viewBox: "0 0 168 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.6C0 16.6392 0 12.1587 1.7439 8.73615C3.27787 5.72556 5.72556 3.27787 8.73615 1.7439C12.1587 0 16.6392 0 25.6 0H142.4C151.361 0 155.841 0 159.264 1.7439C162.274 3.27787 164.722 5.72556 166.256 8.73615C168 12.1587 168 16.6392 168 25.6V142.4C168 151.361 168 155.841 166.256 159.264C164.722 162.274 162.274 164.722 159.264 166.256C155.841 168 151.361 168 142.4 168H25.6C16.6392 168 12.1587 168 8.73615 166.256C5.72556 164.722 3.27787 162.274 1.7439 159.264C0 155.841 0 151.361 0 142.4V25.6Z",
    fill: "#0F0F37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.908 52.1675C109.105 42.1169 97.7522 46.3557 90.7228 50.8384C86.751 53.3712 81.2489 53.3712 77.277 50.8384C70.2477 46.3558 58.8954 42.117 49.0918 52.1675C25.8196 76.0258 65.7295 122 84.0001 122C102.271 122 142.18 76.0258 118.908 52.1675Z",
    stroke: "url(#paint0_linear_1_145196)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.908 52.1675C109.105 42.1169 97.7522 46.3557 90.7228 50.8384C86.751 53.3712 81.2489 53.3712 77.277 50.8384C70.2477 46.3558 58.8954 42.117 49.0918 52.1675C25.8196 76.0258 65.7295 122 84.0001 122C102.271 122 142.18 76.0258 118.908 52.1675Z",
    stroke: "white",
    strokeWidth: 2.37736,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_145196",
    x1: 144.299,
    y1: 139.01,
    x2: 13.7654,
    y2: 141.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C18F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5194D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikedIcon);
export default __webpack_public_path__ + "static/media/LikedIcon.4e3b74d48b9041b9396c97293b5f4cce.svg";
export { ForwardRef as ReactComponent };